import { render, staticRenderFns } from "./DataUpload.vue?vue&type=template&id=81c4ce5a&scoped=true&"
import script from "./DataUpload.vue?vue&type=script&lang=js&"
export * from "./DataUpload.vue?vue&type=script&lang=js&"
import style0 from "./DataUpload.vue?vue&type=style&index=0&id=81c4ce5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c4ce5a",
  null
  
)

component.options.__file = "DataUpload.vue"
export default component.exports